export default [
  {
    title: 'Quiche Lorraine',
    img:
      'https://images.unsplash.com/photo-1490556278693-b666672547a1?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'K16LMHrxEwLG2ZXriMLG',
        title: 'Pâte brisée',
      },
      {
        id: 'Br527H73rGD0cmIvDico',
        title: 'Lardons',
      },
      {
        id: 'fKVbwfg6A7BOCppUwVhH',
        title: 'Crème fraiche',
      },
      {
        id: 'C5Aya1L6M2VajJqZc500',
        title: 'Oeufs',
      },
    ],
  },
  {
    title: 'Patates carrées',
    img:
      'https://images.unsplash.com/photo-1600339240932-226cff938b4f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MXwxODI0MTN8MHwxfHNlYXJjaHw3fHx8ZW58MHwwfHw&ixlib=rb-1.2.1&q=80&w=400',
    ingredients: [],
  },
  {
    title: 'Steak',
    img:
      'https://images.unsplash.com/photo-1588347818036-558601350947?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [],
  },
  {
    title: 'Pâtes carbo',
    img:
      'https://images.unsplash.com/photo-1588013273468-315fd88ea34c?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'ziXditCpdXg2PfMFHqb8',
        title: 'Pâtes',
      },
      {
        id: 'VnKwTrk4sRzHnRhlxslN',
        title: 'Lardons',
      },
      {
        id: 'e2d03Sd2qlww9tOWLFqT',
        title: 'Crème fraiche',
      },
      {
        id: 'ndZlaOIZ17m7g3Vo8Btb',
        title: 'Champignons',
      },
      {
        id: 'VvjB4Y82KYyfdIlLN3gk',
        title: 'Gruyère',
      },
    ],
  },
  {
    title: 'Escalope de dinde',
    img:
      'https://images.unsplash.com/photo-1513134979696-1664819cc84e?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [],
  },
  {
    title: 'Riz',
    img:
      'https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [],
  },
  {
    title: 'Burgers',
    img:
      'https://images.unsplash.com/photo-1571091718767-18b5b1457add?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'DdlR1v0sXBwsyYmcEQ4m',
        title: 'Pain burgers',
      },
      {
        id: 'xTeJ6E7HvGsR6PgFZQRs',
        title: 'Fromage burgers',
      },
      {
        id: 'WcLHqFqWuZmVT40f7uff',
        title: 'Steak haché',
      },
      {
        id: 'UPcGvP8ca8Ib3FzVjuKc',
        title: 'Tomates',
      },
      {
        id: 'rE7jyIg1xKUg9lNpDrpK',
        title: 'Salade',
      },
      {
        id: 'AxKvR47E3Myx7ujGnVUc',
        title: 'Oignons',
      },
      {
        id: 'BXmPV1vwhlnlS5AVFrFo',
        title: 'Ketchup',
      },
    ],
  },
  {
    title: 'Pâtes bolo',
    img:
      'https://images.unsplash.com/photo-1530199320416-f8859a3e988c?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'e0payVXlfSsfaCFkVuL6',
        title: 'Pâtes',
      },
      {
        id: 'gitZJcNgTfondlazE6BI',
        title: 'Bolognaise',
      },
      {
        id: 'DWxRUkStu1q9k3fR4I62',
        title: 'Steak haché',
      },
      {
        id: 'bUYiCa2zRLukn0DB9uek',
        title: 'Gruyère',
      },
    ],
  },
  {
    title: 'Fajitas',
    img:
      'https://images.unsplash.com/photo-1529006557810-274b9b2fc783?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'fHYW9snmcIuC8YRbEoqu',
        title: 'Fajitas',
      },
      {
        id: 'QixImGtsPdg8HnCcHYC5',
        title: 'Poulet',
      },
      {
        id: 'NQ7pPQVTfyDIV9h55Znr',
        title: 'Viande hachée',
      },
    ],
  },
  {
    title: 'Raclette',
    img:
      'https://images.unsplash.com/photo-1582883044880-974679bc1f0d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'EVrWkRqQApKHsOikwdzu',
        title: 'Fromages',
      },
      {
        id: 'ch6JJ9qT8wHRiZFEXcDO',
        title: 'Jambon',
      },
      {
        id: '0te5rASEVpdMe63PujSX',
        title: 'Patates',
      },
      {
        id: 'OL9adfFlgfnMzQRndJns',
        title: 'Bacon',
      },
      {
        id: '16CNw7MGjT5ZL4SPkX3K',
        title: 'Jambon stylé',
      },
    ],
  },
  {
    title: 'Crêpes',
    img:
      'https://images.unsplash.com/photo-1541288097308-7b8e3f58c4c6?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'lMDT3neKCjj8TsNPEnj6',
        title: 'Oeufs',
      },
      {
        id: 'Zn5kKH6BrE1JmnAH8BHV',
        title: 'Farine',
      },
      {
        id: 'va8TihydHyiZMyKY7QhB',
        title: 'Lait',
      },
    ],
  },
  {
    title: 'Pâtes à la norma',
    img:
      'https://images.unsplash.com/photo-1473093226795-af9932fe5856?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'tgx6vV2HZQVzbLmWZrZs',
        title: 'Penne',
      },
      {
        id: 'upzuzUqbGFrPQ8IhA4CA',
        title: 'Aubergines',
      },
      {
        id: 'maKIKB5UFZE700gzvWQ7',
        title: 'Tomates concassées',
      },
      {
        id: 'bRI1ioJFra9b0nzTrJUK',
        title: 'Parmesan',
      },
      {
        id: 'WjNtKtwoFVBjQkOJ36RU',
        title: 'Ail',
      },
      {
        id: 'Z7l6W8XTpvy1OQfurdlg',
        title: 'Farine',
      },
      {
        id: 'yMEO8Yx65qVwKxcCtNVn',
        title: 'Huile olive',
      },
    ],
  },
  {
    title: 'Croques-monsieurs',
    img:
      'https://images.unsplash.com/photo-1531664412848-9610afed156c?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE4MjQxM30',
    ingredients: [
      {
        id: 'sdp7Ss2KhL4K43kETgLy',
        title: 'Jambon',
      },
      {
        id: 'uD5KYZqIS204mEXQTeWE',
        title: 'Pain de mie',
      },
      {
        id: '40ig2kVjCGQItFxjCwDd',
        title: 'Gruyère',
      },
      {
        id: 'DmxwybH6m3DRMIyPmgcl',
        title: 'Crème fraiche',
      },
    ],
  },
];
